@if (form && control) {
  <div [formGroup]="form">
    <app-material-input-radio
      [require]="require"
      [formControlName]="field_name"
      [data]="variants">
      <ng-content></ng-content>
    </app-material-input-radio>
  </div>
}
